export default {
  title: 'Ordenar recursos',
  dragToOrder: 'Arrastra para reordenar',
  cancel: 'Cancelar',
  save: 'Guardar cambios'
}

export const en = {
  title: 'Sort resources',
  dragToOrder: 'Drag to reorder',
  cancel: 'Cancel',
  save: 'Save changes'
}

export const ca = {
  title: 'Ordenar recursos',
  dragToOrder: 'Arrossega per reordenar',
  cancel: 'Cancelar',
  save: 'Desar els canvis'
}
